<template>
  <div class="file_upload">
    <template v-if="url">
      <div class="image-box">
        <template v-if="isPdf">
          <img
            src="@/images/pdf-defalut.png"
            width="80"
            height="80"
            @click.prevent="handleClick()"
          />
        </template>
        <template v-else>
          <img
            :src="link"
            :width="height"
            :height="height"
            @click.prevent="handleClick()"
          />
        </template>
        <br />
        <a :href="link" target="_blank">{{ $lang("查看") }}</a>
      </div>
    </template>
    <template v-else>
      <button
        class="btn btn-info"
        @click.prevent="handleClick()"
        @keydown.prevent="handleKeydown"
        :disabled="loading || disabled"
      >
        <b-spinner
          v-if="loading"
          style="margin-right: 10px"
          small
          label="Small Spinner"
        >
        </b-spinner
        ><span>{{ word }}</span>
      </button>
    </template>
    <input
      type="file"
      class="input"
      ref="input"
      @change="handleChange"
      :accept="accept"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    height: {
      type: Number,
      default: 80,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: String,
    OnSuccess: Function,
    onError: Function,
    value: String,
    word: String,
  },
  data() {
    return {
      url: this.value,
      loading: false,
    };
  },
  created() {},
  computed: {
    link() {
      return this.$store.getters["base/baseUrl"] + this.url;
    },
    isPdf() {
      return this.value.split(".")[1] == "pdf";
    },
  },
  watch: {
    value: {
      handler(n, o) {
        this.url = n;
      },
      deep: true,
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    },
    handleKeydown(e) {
      if (e.target !== e.currentTarget) return;
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.handleClick();
      }
    },
    uploadFiles(file, accept) {
      let formData = new FormData();
      for (var key in file) {
        formData.append(key, file[key]);
      }
      formData.append("file", file);
      // formData.append("accept", 'pdf,gif,jpg,JPG,jpeg,bmp,png');
      this.loading = true;
      this.$apis
        .upload(formData)
        .then((resp) => {
          if (resp.code != 0) {
          } else {
            this.url = resp.data.uri;
            this.$emit("input", resp.data.uri);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChange(ev) {
      const file = ev.target.files[0];
      const accept = this.accept;
      // console.log(file);
      let tip = this.$lang("TEXT.UPLOAD_FILE_TIP")
        .replace(/%mime_type%/, file.type)
        .replace(/%max_size%/, "5");
      if (file.size > 5000000) {
        this.notification.error(tip);
      } else {
        this.uploadFiles(file, accept);
      }
    },
  },
};
</script>

<style lang="scss">
.file_upload {
  // margin-top: 15px;
  position: relative;
  display: inline-block;

  .btn {
    margin-left: 0px;
  }

  .image-box {
    max-width: 120px;
    text-align: center;
    display: inline-block;
  }

  img {
    margin: 0 10px;
  }

  .input {
    display: none;
  }
}
</style>
